import { render } from "./MailTemplates.vue?vue&type=template&id=1a97f3ed&scoped=true"
import script from "./MailTemplates.vue?vue&type=script&lang=ts"
export * from "./MailTemplates.vue?vue&type=script&lang=ts"

import "./MailTemplates.vue?vue&type=style&index=0&id=1a97f3ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a97f3ed"

export default script